<template>
  <div class="expand-block">
    <EditorJSComponent
      class="expand-block__text"
      :class="{ 'expand-block__text--expanded': expand }"
      ref="text"
      :text="parsedText"
    />
    <button @click="expandToggle" class="expand-block__button btn btn--sm btn--main-inv">
      <span v-if="expand">Скрыть</span>
      <span v-else>Показать все</span>
    </button>
  </div>
</template>

<script>
import EditorJSComponent from "components/EditorJSComponent.vue";
import { elementInViewport } from "@/utils";

export default {
  name: "ExpandComponent",
  props: {
    text: String,
  },
  data() {
    return {
      expand: false,
    };
  },
  computed: {
    parsedText() {
      try {
        return JSON.parse(this.text);
      } catch (e) {
        return {};
      }
    },
  },
  methods: {
    expandToggle() {
      this.expand = !this.expand;
      const el = this.$refs.text.$el;
      if (this.expand) {
        el.style.maxHeight = el.scrollHeight + "px";
      } else {
        el.style.maxHeight = "300px";
        this.scrollIntoView(el);
      }
    },
    scrollIntoView(el) {
      setTimeout(() => {
        if (!elementInViewport(el)) {
          el.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
        }
      }, 100);
    },
  },
  components: { EditorJSComponent },
};
</script>

<style lang="stylus">
.expand-block {
	&__text {
		position: relative
		max-height: 300px
		overflow hidden
		transition var(--transition)

		& > * {
			flex-shrink 0
		}

		&:not(&--expanded) {
			&:after {
				content ""
				display block
				width 100%
				height 120px
				position absolute
				bottom 0
				background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, var(--white) 100%)
				pointer-events: none
			}
		}
	}

	&__button {
		margin-top 10px
		width 100%
		max-width 200px
	}
}
</style>
